import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fillRule="nonzero" fill="none">
      <path d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z" stroke={color} strokeWidth="2" />
      <path fill={color} d="M16 13H8v-2h8z" />
    </g>
  </svg>
);
